var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "PortalWidget",
    {
      attrs: { widget: _vm.widget },
      scopedSlots: _vm._u([
        {
          key: "headerContent",
          fn: function() {
            return [
              _c(
                "div",
                { staticClass: "header-extra" },
                [
                  _c("ColumnToggle", {
                    attrs: {
                      "table-name": "authConnections",
                      "user-settings": _vm.userSettings,
                      "settings-status": _vm.getUserSettingsStatus,
                      "column-settings": _vm.columnSettings
                    },
                    on: { onChange: _vm.updateUserVisibleColumns }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.filterValue,
                        expression: "filterValue"
                      }
                    ],
                    staticClass:
                      "form-control input-md widget-header-input m-r-10",
                    attrs: { type: "search", placeholder: _vm.$t("SEARCH") },
                    domProps: { value: _vm.filterValue },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) return
                        _vm.filterValue = $event.target.value
                      }
                    }
                  })
                ],
                1
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      !_vm.loading
        ? _c("div", { staticClass: "m-b-15" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-success btn-sm",
                attrs: { type: "button", disabled: _vm.showCreateForm },
                on: {
                  click: function($event) {
                    return _vm.toggleForm(true)
                  }
                }
              },
              [
                _c("i", { staticClass: "fa fa-plus" }),
                _vm._v(" "),
                _c("span", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "ACTION_CREATE_AUTH_CONNECTION",
                      expression: "'ACTION_CREATE_AUTH_CONNECTION'"
                    }
                  ]
                })
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading
        ? _c(
            "div",
            { staticClass: "grid_table_holder" },
            [
              _c(
                "v-table",
                {
                  staticClass: "table_beauty",
                  attrs: {
                    data: _vm.authConnections,
                    "current-page": _vm.currentPage,
                    "page-size": 20,
                    filters: _vm.filters,
                    "hide-sort-icons": true
                  },
                  on: {
                    "update:currentPage": function($event) {
                      _vm.currentPage = $event
                    },
                    "update:current-page": function($event) {
                      _vm.currentPage = $event
                    },
                    totalPagesChanged: function($event) {
                      _vm.totalPages = $event
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "body",
                        fn: function({ displayData }) {
                          return _c(
                            "tbody",
                            {},
                            [
                              _c("tr", [
                                _vm.emptyTable && !_vm.showCreateForm
                                  ? _c("td", {
                                      directives: [
                                        {
                                          name: "t",
                                          rawName: "v-t",
                                          value: "AUTH_CONNECTIONS_TABLE_EMPTY",
                                          expression:
                                            "'AUTH_CONNECTIONS_TABLE_EMPTY'"
                                        }
                                      ],
                                      attrs: { colspan: "100%" }
                                    })
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _vm.showCreateForm
                                ? _c(
                                    "tr",
                                    {
                                      staticClass:
                                        "row-inline-new-form slide-down bg-row-even"
                                    },
                                    [
                                      _c(
                                        "td",
                                        { attrs: { colspan: "100" } },
                                        [
                                          _c("AuthConnectionsForm", {
                                            attrs: {
                                              "show-loader":
                                                _vm.createAuthConnectionStatus
                                                  .status === "pending",
                                              "is-new-url-parameter": true
                                            },
                                            on: {
                                              cancel: function($event) {
                                                return _vm.toggleForm(false)
                                              },
                                              submit: _vm.createAuth
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(displayData, function(row, index) {
                                return [
                                  !(
                                    _vm.isMobile &&
                                    _vm.activeActionRowId == row.id
                                  )
                                    ? _c(
                                        "tr",
                                        {
                                          key: row.id,
                                          class: {
                                            "bg-row-odd": index % 2 === 0,
                                            "bg-row-even": index % 2 !== 0
                                          }
                                        },
                                        [
                                          _vm.isMobile
                                            ? _c("td", [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-list-function btn-expand-actions",
                                                    attrs: {
                                                      disabled:
                                                        _vm.showCreateForm
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.displayMobileAction(
                                                          row.id
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-ellipsis-v"
                                                    })
                                                  ]
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.userVisibleColumns.includes(
                                            "name"
                                          )
                                            ? _c(
                                                "td",
                                                {
                                                  staticClass: "clickable",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.displayEditForm(
                                                        row.id
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n              " +
                                                      _vm._s(row.name) +
                                                      "\n            "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.userVisibleColumns.includes("url")
                                            ? _c("td", [
                                                _vm._v(
                                                  "\n              " +
                                                    _vm._s(row.url) +
                                                    "\n            "
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.userVisibleColumns.includes(
                                            "lastUsedAt"
                                          )
                                            ? _c("td", [
                                                _vm._v(
                                                  "\n              " +
                                                    _vm._s(
                                                      _vm.formatDate(
                                                        row.lastUsedAt
                                                      )
                                                    ) +
                                                    "\n            "
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.userVisibleColumns.includes(
                                            "status"
                                          )
                                            ? _c(
                                                "td",
                                                { staticClass: "text-center" },
                                                [
                                                  _c("span", {
                                                    directives: [
                                                      {
                                                        name: "tooltip",
                                                        rawName:
                                                          "v-tooltip.right",
                                                        value: _vm.getStatusMessage(
                                                          row
                                                        ),
                                                        expression:
                                                          "getStatusMessage(row)",
                                                        modifiers: {
                                                          right: true
                                                        }
                                                      }
                                                    ],
                                                    staticClass: "color-dot",
                                                    class: {
                                                      yellow_status:
                                                        row.isConnectionHealthy ==
                                                        null,
                                                      green_status:
                                                        row.isConnectionHealthy,
                                                      red_status:
                                                        row.isConnectionHealthy ===
                                                        false
                                                    }
                                                  })
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.isMobile
                                            ? _c(
                                                "td",
                                                [
                                                  _c("AuthConnectionsActions", {
                                                    attrs: {
                                                      "current-auth-connection": row,
                                                      disabled: _vm.disabled,
                                                      "get-references-status":
                                                        _vm.getReferencesStatus,
                                                      "delete-auth-connection-status":
                                                        _vm.deleteAuthConnectionStatus,
                                                      references: _vm.references
                                                    },
                                                    on: {
                                                      edit: _vm.displayEditForm,
                                                      "open-delete":
                                                        _vm.getAuthReferences,
                                                      "confirm-delete":
                                                        _vm.deleteAuth,
                                                      validate: _vm.validateAuth
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.showEditForm(row.id)
                                    ? _c(
                                        "tr",
                                        {
                                          key: row.id + "-edit",
                                          staticClass:
                                            "row-inline-new-form slide-down bg-row-even"
                                        },
                                        [
                                          _c(
                                            "td",
                                            { attrs: { colspan: "100" } },
                                            [
                                              _c("AuthConnectionsForm", {
                                                attrs: {
                                                  "show-loader":
                                                    _vm
                                                      .updateAuthConnectionStatus
                                                      .status === "pending",
                                                  "current-auth-connection": row,
                                                  "is-new-url-parameter": false
                                                },
                                                on: {
                                                  cancel: _vm.hideEditForm,
                                                  submit: _vm.updateAuth
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isMobile &&
                                  _vm.activeActionRowId == row.id
                                    ? _c(
                                        "tr",
                                        {
                                          key: row.id + "-mobile",
                                          staticClass:
                                            "mobile-actions ng-animate-disabled slide-right"
                                        },
                                        [
                                          _c(
                                            "td",
                                            { attrs: { colspan: "10" } },
                                            [
                                              _c("AuthConnectionsActions", {
                                                attrs: {
                                                  "current-auth-connection": row,
                                                  disabled: _vm.disabled,
                                                  "get-references-status":
                                                    _vm.getReferencesStatus,
                                                  "delete-auth-connection-status":
                                                    _vm.deleteAuthConnectionStatus,
                                                  references: _vm.references
                                                },
                                                on: {
                                                  "collapse-actions": function(
                                                    $event
                                                  ) {
                                                    !_vm.disabled &&
                                                      _vm.hideMobileAction()
                                                  },
                                                  edit: _vm.displayEditForm,
                                                  "open-delete":
                                                    _vm.getAuthReferences,
                                                  "confirm-delete":
                                                    _vm.deleteAuth
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              })
                            ],
                            2
                          )
                        }
                      }
                    ],
                    null,
                    false,
                    2107622094
                  )
                },
                [
                  _c("thead", { attrs: { slot: "head" }, slot: "head" }, [
                    _c(
                      "tr",
                      [
                        _vm.isMobile ? _c("th") : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.userVisibleColumns, function(col) {
                          return _c("v-th", {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: _vm.columnSettings[col].displayName,
                                expression: "columnSettings[col].displayName"
                              }
                            ],
                            key: col,
                            class: _vm.columnSettings[col].class,
                            attrs: {
                              "default-sort":
                                _vm.columnSettings[col].defaultSort,
                              "sort-key": _vm.columnSettings[col].name
                            }
                          })
                        }),
                        _vm._v(" "),
                        !_vm.isMobile
                          ? _c("th", {
                              directives: [
                                {
                                  name: "t",
                                  rawName: "v-t",
                                  value: "TABLE_COL_ACTIONS",
                                  expression: "'TABLE_COL_ACTIONS'"
                                }
                              ]
                            })
                          : _vm._e()
                      ],
                      2
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "pagination-min" }, [
                _c(
                  "div",
                  { staticClass: "text-center p-7" },
                  [
                    _c("smart-pagination", {
                      attrs: {
                        "current-page": _vm.currentPage,
                        "total-pages": _vm.totalPages,
                        "max-page-links": 20
                      },
                      on: {
                        "update:currentPage": function($event) {
                          _vm.currentPage = $event
                        },
                        "update:current-page": function($event) {
                          _vm.currentPage = $event
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loading
        ? _c(
            "div",
            { staticClass: "text-center empty-records" },
            [
              _c("Loader"),
              _vm._v(" "),
              _c("span", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "AUTH_CONNECTIONS_TABLE_LOADING",
                    expression: "'AUTH_CONNECTIONS_TABLE_LOADING'"
                  }
                ]
              })
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }